import { render } from "./Edit25Liquidation4.vue?vue&type=template&id=2efe1094"
import script from "./Edit25Liquidation4.vue?vue&type=script&lang=js"
export * from "./Edit25Liquidation4.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__